import { MailingAddressDetails } from "../redux/reducers/getPropMailingAddressReducer/mailingAddress";

export default function massageJson(data: MailingAddressDetails) {
    const temp: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(data)) {
        if(!value) {
            temp[key] = "";
        }else {
            temp[key] = value
        }
      } 
    return temp;
}